import { InferType, array, boolean, object, string } from 'yup';

export const affiliateValidator = object({
  uid: string().required(),
  telegramHandle: string(),
  typesOfAffiliate: array().of(string()).required().min(1),
  otherExchangesPromoted: string().required(),
  channelsToPromotePrex: array().of(string()).required().min(1),
  socialLinks: string(),
  sizeOfSocialFollowing: string().required(),
  howFoundPrex: array().of(string()).required().min(1),
  prexBizdevContact: string().required(),
  agreeToAffiliateProgramTermsAndPolicy: boolean().required(),
});

export type AffiliateSchema = InferType<typeof affiliateValidator>;
